import { TelemetryInitializerFunc } from './models';
import { tagTelemetryInitializer } from './tag-telemetry-initializer';

export const cloudRoleTelemetryInitializer = (name: string): TelemetryInitializerFunc =>
  tagTelemetryInitializer('ai.cloud.role', name);
